// Generates a short, prefixed client-side id (e.g. "mod-lq3x9f") for new
// list items in the admin editors before they are persisted. Not
// cryptographically unique — only needs to be stable within an editing
// session and distinct enough to use as a React key / lookup handle.

export function generateId(prefix: string): string {
  return `${prefix}-${Date.now().toString(36)}`;
}
